import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import historyTwoTrainersData from '../data/HistoryTwo';
import './HistoryTwo.css';

const HistoryTwoTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(historyTwoTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('🎨 Renaissance Master/Scientific Visionary selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/history-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/history-train-categories');
    };

    return (
        <div className="history-trainers-container">
            <div className="history-animated-background masterpiece-flow"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="history-trainers-header">
                <div className="header-content">
                    <h1>Renaissance Masters & Scientific Visionaries</h1>
                    <p>Train with legendary artists, inventors, and revolutionary thinkers</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Renaissance & Science</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="history-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="history-trainer-card floating-innovation-element enlightenment-shimmer"
                        onClick={() => handleTrainerSelect(trainer)}
                        data-character={trainer.id}
                        style={{
                            '--history-primary-color': trainer.color,
                            '--history-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Character-specific accent icons */}
                        {trainer.id === 'michelangelo' && <div className="palette-accent"></div>}
                        {trainer.id === 'galileo-galilei' && <div className="telescope-accent"></div>}
                        {trainer.id === 'isaac-newton' && <div className="compass-accent"></div>}
                        {trainer.id === 'albert-einstein' && <div className="compass-accent"></div>}
                        {trainer.id === 'nikola-tesla' && <div className="compass-accent"></div>}
                        {trainer.id === 'pablo-picasso' && <div className="palette-accent"></div>}

                        {/* Trainer Image */}
                        <div className="history-trainer-image-section">
                            <div
                                className="history-trainer-image invention-spark"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="renaissance-aura-effect"></div>
                                <div className="experience-badge history-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="history-trainer-info-section canvas-texture">
                            <h3 className="history-trainer-name">{trainer.name}</h3>
                            <p className="history-trainer-specialization">{trainer.specialization}</p>
                            <p className="history-trainer-description">{trainer.intro}</p>

                            <div className="history-trainer-details">
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">🎨</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">🔬</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Renaissance Divider */}
            <div className="renaissance-divider"></div>

            {/* Footer */}
            <div className="history-trainers-footer scientific-pattern">
                <div className="history-info">
                    <h3>Renaissance Masters & Scientific Visionaries Philosophy</h3>
                    <div className="history-benefits-grid">
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🎨</div>
                            <div>
                                <strong>Sculptural Power Endurance</strong>
                                <p>Four years of ceiling painting strength and marble-carving precision that transforms raw material into divine beauty</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🔭</div>
                            <div>
                                <strong>Telescopic Scientific Method</strong>
                                <p>Steady observation skills and the courage to defend revolutionary truths against established doctrine</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🍎</div>
                            <div>
                                <strong>Universal Law Discovery</strong>
                                <p>Mathematical genius training that reveals the hidden laws governing motion, gravity, and universal forces</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">⚡</div>
                            <div>
                                <strong>Electrical Innovation Mastery</strong>
                                <p>Visionary engineering that harnesses lightning and creates the electrical foundation of modern civilization</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🌌</div>
                            <div>
                                <strong>Relativity Thought Experiments</strong>
                                <p>Mind-bending training that uses imagination to unlock the deepest secrets of space, time, and reality</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🖼️</div>
                            <div>
                                <strong>Cubist Multi-Perspective Revolution</strong>
                                <p>Artistic training that sees reality from all angles simultaneously and creates entirely new forms of expression</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoryTwoTrainers;